import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TabPillGroupButton, TabPillGroupButtonComponent } from 'src/app/shared/components/tab-pill-group-button/tab-pill-group-button.component';

@Component({
  selector: 'app-step-three',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, TabPillGroupButtonComponent],
  templateUrl: './step-three.component.html',
  styleUrl: './step-three.component.css'
})
export class StepThreeComponent {
  public caseItem: string | null = null;
  public tabPillGroupButtons: TabPillGroupButton[] = [
    {
      key: 'credit-debit-card',
      title: 'Πιστωτική / Χρεωστική Κάρτα',
    },
    {
      key: 'bank-transfer',
      title: 'Κατάθεση σε τράπεζα',
    }
  ];

  handleButtonGroupItemSelected(item: any) {
    console.log('Selected Item:', item);
    this.caseItem = item;
  }
}
